import {API} from '../../networking/http'
import {MutationMethod} from '../helpers/types'
import {User} from '../user/types'

export type PhoneLoginVerifyParams = undefined
export type PhoneLoginVerifyMutationParams = {
  idToken: string
}
export type PhoneLoginVerifyMutationReturnType = {
  status: 'needs_email' | 'success'
  customToken?: string
  user?: User
}
export type PhoneLoginVerifyMutation = MutationMethod<
  PhoneLoginVerifyParams,
  PhoneLoginVerifyMutationParams,
  PhoneLoginVerifyMutationReturnType
>

export const makePhoneLoginVerifyEndpoint = () => 'users/phone-login/verify'

export const phoneLoginVerifyMutation: PhoneLoginVerifyMutation = () => ({
  mutationFn: ({idToken}) =>
    API.post<unknown, PhoneLoginVerifyMutationReturnType>(
      makePhoneLoginVerifyEndpoint(),
      {},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    ).then((res) => res.data),
})
